import { allOrderStates } from '../../status-transition-rules/order-rules';
import TableFilter from '../table-models/TableFilter';

export const defaultOrdersFilters: TableFilter[] = [
    { field: 'state', label: 'State', value: '', availableStates: allOrderStates }
];
